<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="note">
              <strong>Ghi chú:</strong>
              <div class="group-content-note">
                <div>Dấu <span class="required">*</span> là bắt buộc phải điền</div>
                <!--                <div>Tài khoản tối thiểu 6, tối đa 100 kí tự bao gồm chữ thường và số</div>-->
                <!--                <div>Mật khẩu tối thiểu 8, tối đa 128 kí tự bao gồm chữ hoa, chữ thường, số và kí tự đặc biệt là 1 trong-->
                <!--                  số kí tự này @$!%*?&-->
                <!--                </div>-->
                <div>Số điện thoại gồm 10 kí tự và đúng định số điện thoại nước Việt Nam không bao gồm SĐT cố định. Ví
                  dụ: 033*****00 hoặc
                  8433*****00
                </div>
                <div>Email phải đúng định dạng. Ví dụ: demo@com.vn</div>
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <CForm class="form-basic" v-on:submit.prevent>
              <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                  <CRow>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect :options="rolesSelect.options" :data="rolesSelect.data"
                                  ref="rolesSelect"></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect :options="locationSelect.options" :data="locationSelect.data"
                                  ref="locationSelect"></BaseSelect>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="userNameInput.options" :data="userNameInput.data"/>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="fullNameInput.options" :data="fullNameInput.data"/>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="phoneInput.options" :data="phoneInput.data"/>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="emailInput.options" :data="emailInput.data"/>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect :options="isEnabledSelect.options" :data="isEnabledSelect.data"
                                  ref="isEnabledSelect"></BaseSelect>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData()">
                  <i class="fa fa-refresh"></i> Cập nhật
                </CButton>
                <CButton color="secondary" class="btn-action-primary" @click="$router.go(-1)"><i
                  class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import {Authorities, PROVINCE_CODE, PROVINCE_NAME} from "@/constant";

export default {
  name: "UserUpdate",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      userInfo: null,
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id"
        }
      },
      /* Username */
      userNameInput: {
        options: {
          label: "Tên đăng nhập <span class='required'>*</span>",
          placeholder: "Tên đăng nhập",
          type: "text",
          // append: '',
          readonly: true
        },
        data: {
          name: "username",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
      /* Password */
      // passwordInput: {
      //   options: {
      //     label: "Mật khẩu *",
      //     placeholder: "Mật khẩu",
      //     type: "password"
      //   },
      //   data: {
      //     name: "password",
      //     model: "",
      //   }
      // },
      /* IsEnable */
      isEnabledSelect: {
        options: {
          label: "Trạng thái <span class='required'>*</span>",
          placeholder: "Trạng thái",
          filter: false,
        },
        data: {
          name: "enabled",
          items: [
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Vô hiệu hóa"},
          ],
          model: "",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
      /* FullName */
      fullNameInput: {
        options: {
          label: "Họ Tên <span class='required'>*</span>",
          placeholder: "Họ và tên",
        },
        data: {
          name: "fullName",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fullNameInput.data.model;
              let fullname_regex = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪếễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựýỳỵỷỹ ]+$/;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Họ và tên không được để trống";
              } else if (fullname_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Họ và tên không đúng định dạng";
              } else if (fullname_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      /* Phone */
      phoneInput: {
        options: {
          label: "Số điện thoại <span class='required'>*</span>",
          placeholder: "Số điện thoại",
          type: "number"
        },
        data: {
          name: "phone",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.phoneInput.data.model;
              let phone_regex = /^(0[3|5|7|8|9])+([0-9]{8})$/
              let phone_regex2 = /^(84[3|5|7|8|9])+([0-9]{8})$/
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Số điện thoại không được để trống";
              } else if (phone_regex.test(value) == false && phone_regex2.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Số điện thoại sai định dạng";
              } else if (phone_regex.test(value) == true || phone_regex2.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Address */
      addressInput: {
        options: {
          label: "Địa chỉ <span class='required'>*</span>",
          placeholder: "Địa chỉ",
        },
        data: {
          name: "address",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.addressInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Địa chỉ không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      /* Email */
      emailInput: {
        options: {
          label: "Email <span class='required'>*</span>",
          placeholder: "Email",
        },
        data: {
          name: "email",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.emailInput.data.model;
              let email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Email không được để trống";
              } else if (email_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Email không đúng định dạng";
              } else if (email_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      /* Role */
      rolesSelect: {
        options: {
          label: "Nhóm người dùng tài khoản <span class='required'>*</span>",
          filter: false,
          'keyField': 'value',
          'valueField': 'text',
        },
        data: {
          model: "",
          name: "role",
          items: [],
        }
      },
      /* Location */
      locationSelect: {
        options: {
          lazyLoad: true,
          label: "Địa phương tài khoản <span class='required'>*</span>",
          selectAllText: "Chọn địa phương",
          'keyField': 'key',
          'valueField': 'value',
          disabled: true,
        },
        data: {
          model: "",
          name: 'locationCode',
          items: [],
          source: {
            url: "/common/findAllLocationByLevel",
            isJsonContentType: false,
            dataSubmit() {
              let _level = 0;
              if (that.rolesSelect.data.model == Authorities.ROLE_DISTRICT) {
                _level = 1;
              } else if (that.rolesSelect.data.model == Authorities.ROLE_WARD) {
                _level = 2;
              }
              return {
                level: _level,
              }
            },
            response: function (dataResponse) {
              that.locationSelect.data.items = dataResponse.data
              setTimeout(() => {
                that.locationSelect.data.model = that.userInfo.locationCode
              }, 10)
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.locationSelect.data.model;
              let roleValue = that.rolesSelect.data.model;
              if (value == "" && (roleValue != Authorities.ROLE_ADMIN)) {
                this.isValid = false;
                this.errorMessage = "Địa phương không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          },
        }
      },
    }
  },
  methods: {
    loadDataRoles() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/role/listRole",
        successCallback: function (response) {
          that.rolesSelect.data.items = response.data.data;
          that.loadData();
          // that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    loadData() {
      let that = this;
      this.$helper.loadDataSource({
        // loading: that.loading,
        url: "/users/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        successCallback: function (response) {
          let convertUsername = response.data.data.username.split('_');
          response.data.data.username = convertUsername[0];
          response.data.data.enabled = response.data.data.enabled == true ? 1 : 0;
          // that.userNameInput.options.append = convertUsername[1];
          that.dataCache = that.userInfo = response.data.data;
          that.$helper.setupDataResponse(that.$data, response.data.data);
          // that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          // that.loading.value = false
        }
      });
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.locationSelect.data.validator.valid();
      isValid &= this.phoneInput.data.validator.valid();
      isValid &= this.emailInput.data.validator.valid();
      isValid &= this.addressInput.data.validator.valid();
      isValid &= this.fullNameInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      let locationCode = (this.rolesSelect.data.model == Authorities.ROLE_ADMIN) ? PROVINCE_CODE : this.locationSelect.data.model;
      let dataRequest = {
        id: this.idField.data.model,
        role: this.rolesSelect.data.model,
        locationCode: locationCode,
        phone: this.phoneInput.data.model,
        email: this.emailInput.data.model,
        address: this.addressInput.data.model,
        enabled: this.isEnabledSelect.data.model == 0 ? false : true,
        fullName: this.fullNameInput.data.model,
      }

      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/updateUser",
        type: 'PUT',
        dataValid: function () {
          return that.dataCache;
        },
        dataSubmit: function () {
          return dataRequest;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cập nhật tài khoản thành công"});
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadDataRoles();
  },
  watch: {
    'rolesSelect.data.model': function (value) {
      if (value == Authorities.ROLE_DISTRICT || value == Authorities.ROLE_WARD) {
        this.$refs.locationSelect.loadData();
        this.locationSelect.options.disabled = false;
        // this.userNameInput.options.append = 'N/A';
      } else {
        // this.userNameInput.options.append = `_${PROVINCE_CODE}`;
        this.locationSelect.data.items = [];
        this.locationSelect.options.disabled = true;
        this.addressInput.data.model = PROVINCE_NAME;
      }
      // this.locationSelect.data.validator.valid();
    },
    'locationSelect.data.model': function (value) {
      if (this.rolesSelect.data.model == Authorities.ROLE_ADMIN) {
        // this.userNameInput.options.append = `_${PROVINCE_CODE}`;
        this.addressInput.data.model = PROVINCE_NAME;
      } else {
        if (value && value != undefined) {
          // this.userNameInput.options.append = `_${value}`;
          this.addressInput.data.model = this.$refs.locationSelect.getTextSelected;
          // this.isChangeLocation = true
        } else {
          // this.userNameInput.options.append = 'N/A';
        }
      }
    }
  }
};
</script>
